import React, { useState } from 'react'
import { ProductSimple } from '@interfaces/product'
import ProductCardSimple from '@components/molecules/ProductCardSimple'

export interface ProductListProps {
  products: ProductSimple[]
  collectionTitle?: string
  productLimit?: number
}

const ProductList: React.FC<ProductListProps> = ({ products, collectionTitle, productLimit = 4 }) => {
  const [visibleProducts, setVisibleProducts] = useState<ProductSimple[]>(products.slice(0, productLimit))
  const [nextProductIndex, setNextProductIndex] = useState<number>(productLimit)
  const [newProductKey, setNewProductKey] = useState(0) // Key to force re-render of the new product card

  const handleDeleteAndReplace = (index: number) => {
    const newProducts = [...visibleProducts]
    newProducts.splice(index, 1)

    const newProduct = products[nextProductIndex]
    newProducts.push(newProduct)
    setNextProductIndex((nextProductIndex + 1) % products.length) // if last product, resets to 0
    setNewProductKey(newProductKey + 1) // Increment key to force re-render


    setVisibleProducts(newProducts)
  }

  return (
    <div className="grid gap-x-5 gap-y-12 grid-cols-2 lg:grid-cols-4 lg:gap-x-8 lg:gap-y-16">
      {!!visibleProducts.length &&
        visibleProducts.map((product: ProductSimple, index: number) => (
          <ProductCardSimple
            key={index === visibleProducts.length - 1 ? `new-${newProductKey}` : product.handle}
            product={product}
            collectionTitle={collectionTitle}
            onDeleteAndReplace={() => handleDeleteAndReplace(index)}
            className={index === visibleProducts.length - 1 ? 'fade-in' : ''}
          />
        ))}
    </div>
  )
}

export default ProductList
